export default __webpack_public_path__ + "static/media/loyalty-card@3x.f26a2728.jpg";